import { Alert, Grid, FormControlLabel, Button, Checkbox } from "@mui/material";
import { useState, FormEvent } from "react";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { Link, redirect, useNavigate } from "react-router-dom";
import { PrimaryButton } from "../../_components/button/primary.button";
import { PaperHeader } from "../../_components/paper/header.paperComponent";
import { TextValidatorHcs } from "../../_components/textValidator/textValidatorHcs";
import { toastr } from "../../_components/toastr/toastr";
import { accountService } from "../../_services/accounts.service";
import { theme } from "../../_styles/theme.styles";

const useStyles = {
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: theme.spacing(2)
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
        "&>div>div": {
            marginTop: "10px"
        }
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    header: {
        marginLeft: theme.spacing(-8),
    },
    appLogo: {
        width: "100%",
        marginBottom: theme.spacing(2),
    },
    appContainer: {
        paddingTop: theme.spacing(4),
    },
    link: {
        paddingTop: "20px",
        cursor: "pointer"
    },
};

export function LoginIndex() {

    let navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [rememberMe, setRememberMe] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");

    function submit(e: FormEvent) {
        e.preventDefault();
        setLoading(true);
        setErrorMsg("");

        accountService.login(username, password, rememberMe)
            .then(
                (item => {
                    navigate("/login/verifycode/email=" + item.email);
                }),
                ((err) => {
                    if (err === 'Username or password is incorrect') { setErrorMsg(err); }
                    else { toastr.error("Something went wrong. Please try again later"); }
                }))
            .finally(() => { setLoading(false); });
    }

    if (accountService.currentUserValue) {
        redirect('/');
    }

    return (
        <div style={useStyles.paper as React.CSSProperties}>
            <div style={useStyles.header}>
                <PaperHeader title='Sign In' icon='lock'></PaperHeader>
            </div>

            {errorMsg &&
                <Alert severity="error">{errorMsg}!</Alert>
            }

            <Alert severity="warning">

                We have recently updated our motorsport management system.<br /><br />
                

                If you are accessing the system for the first time since the update issued on 18 December 2024, please click the “Forgot Password” button to generate a new login for your existing account. You do not have to to do this for every visit, just the first visit since this update. <br /> <br />

                If it is your first time and have never held a motorsport licence with us before, please create a new account.
            </Alert>



            <ValidatorForm sx={useStyles.form} onSubmit={submit} noValidate>
                <Grid container>

                    <Grid item xs={12}>
                        <TextValidatorHcs
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            label="Email"
                            name="email"
                            value={username}
                            disabled={isLoading}
                            onChange={(e: any) => setUsername(e.target.value.toString())}
                            validators={['required', 'isEmail']}
                            errorMessages={['This field is required', 'Email is not valid']}
                            autoFocus
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextValidatorHcs
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            type="password"
                            id="password"
                            disabled={isLoading}
                            value={password}
                            onChange={(e: any) => setPassword(e.target.value.toString())}
                            validators={['required']}
                            errorMessages={['This field is required']}
                            autoComplete="current-password"
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <FormControlLabel
                            disabled={isLoading}
                            value={rememberMe}
                            onChange={(e: any) => setRememberMe(!rememberMe)}
                            control={<Checkbox value="remember" color="primary" />}
                            label="Remember me"
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <PrimaryButton
                            type="submit"
                            disabled={isLoading}
                            variant="primary"
                            icon="login"
                        >
                            Sign In
                        </PrimaryButton>
                    </Grid>
                </Grid>
            </ValidatorForm>
            <Grid container >
                <Grid item xs={6}>
                    <Link to={"forgotpassword"} style={{ marginLeft: "30%" }}>
                        Forgot Password
                    </Link>
                </Grid>
                <Grid item xs={6}>
                    <Link to={"register"} style={{ marginLeft: "35%" }}>
                        Register
                    </Link>
                </Grid>
            </Grid>

        </div>
    );
}